export var formatCurrency = function (amount, code) {
    return new Intl.NumberFormat('en-US', { style: 'currency', currency: code }).format(amount).replace(/[^,.-\d]+/g, '');
};
export var formatUSD = function (amount) { return "USD " + formatCurrency(amount, 'USD'); };
//# sourceMappingURL=currency-formatter.js.map